var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6904 46.3304C24.6584 46.3304 26.2538 44.735 26.2538 42.767C26.2538 40.799 24.6584 39.2036 22.6904 39.2036C20.7223 39.2036 19.127 40.799 19.127 42.767C19.127 44.735 20.7223 46.3304 22.6904 46.3304Z",
    stroke: "#5070DE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2153 46.3304C40.1833 46.3304 41.7787 44.735 41.7787 42.767C41.7787 40.799 40.1833 39.2036 38.2153 39.2036C36.2472 39.2036 34.6519 40.799 34.6519 42.767C34.6519 44.735 36.2472 46.3304 38.2153 46.3304Z",
    stroke: "#5070DE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4301 14.4986L18.6408 27.8304C19.2881 29.8792 19.6107 30.9036 20.2329 31.6619C20.7776 32.3323 21.4878 32.8497 22.2901 33.1702C23.2014 33.5326 24.274 33.5326 26.4233 33.5326H34.4991C36.6485 33.5326 37.7211 33.5326 38.6303 33.1702C39.4347 32.8497 40.1428 32.3323 40.6895 31.6619C41.3096 30.9036 41.6322 29.8792 42.2817 27.8304L43.1385 25.1154L43.6412 23.5108L44.3347 21.3111C44.5821 20.5266 44.6413 19.6948 44.5073 18.8832C44.3734 18.0715 44.0502 17.3028 43.5638 16.6394C43.0774 15.9759 42.4416 15.4364 41.7079 15.0645C40.9741 14.6925 40.1631 14.4987 39.3404 14.4986H14.4301ZM14.4301 14.4986L14.407 14.4211C14.3186 14.1248 14.2208 13.8314 14.1137 13.5412C13.6896 12.4677 12.9704 11.5361 12.0392 10.854C11.108 10.1719 10.0028 9.76722 8.85138 9.68668C8.6356 9.66992 8.39888 9.66992 7.92334 9.66992",
    stroke: "#5070DE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/emptyCart.005bd71d024485c9d21522885e8d7a9f.svg";
export { ForwardRef as ReactComponent };